export const apiPath = '/v2/contracts';
const actionType = 'CONTRACT_USERS';

export const assignedActionType = `${actionType}_ASSIGNED`;
export const unassignedActionType = `${actionType}_UNASSIGNED`;

export default actionType;
